// has-farm.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoginService } from './services/login.service';
import { ProfilePageService } from './services/profile-page.service';

@Injectable({
  providedIn: 'root'
})
export class HasFarmGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private profilePageService: ProfilePageService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const loggedInUserInfo = this.loginService.GetLoggedInUserInfo();
    
    if (!loggedInUserInfo) {
      console.log('User is not logged in, redirecting to login page');
      this.router.navigate(['/login']);
      return false;
    }

    console.log('User is logged in, checking if they have a farm');
    
    return this.profilePageService.getFarmInfo(loggedInUserInfo.userID).pipe(
      map(response => {
        const hasFarm = response.body?.farmID !== undefined;
        if (hasFarm) {
          console.log('User has a farm, redirecting to market page');
          this.router.navigate(['/market']); // Change to the desired route
          return false; // Do not allow route if user has a farm
        } else {
          console.log('User does not have a farm, allowing access to register farm page');
          return true; // Allow route if user does not have a farm
        }
      }),
      catchError(error => {
        if (error.status === 404) {
          console.log('User does not have a farm (404), allowing access to register farm page');
          return of(true); // Allow route if user does not have a farm
        } else {
          console.error('An error occurred while fetching farm info:', error);
          // Handle other error cases, e.g., show an error message or redirect
          this.router.navigate(['/error']); // Change to the desired route
          return of(false);
        }
      })
    );
  }
}
